"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManouverIconLabel = exports.WrapperLabels = exports.DatetimeOtherData = exports.LocationOtherData = exports.WrapperOtherData = exports.LabelWrapper = exports.NumberLevelShipment = exports.TitleLevelShipment = exports.ContainerLevelShipment = exports.WrapperShipmentLevel = exports.CourierLogoImgShipment = exports.CourierLogoShipment = exports.CompanyLogoImgShipment = exports.CompanyLogoShipment = exports.WrapperShipmentLogos = exports.TitleWrapperShipment = exports.FolioShipment = exports.TravelShipment = exports.IconSmallShipment = exports.IconShipment = exports.WrapperShipmentInfo = exports.WrapperShipment = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentCardStyles__Wrapper",
  componentId: "sc-71wkur-0"
})(["background:#2f3b52;border-radius:0.6rem;width:95%;margin:0.5rem auto;padding:0.6rem 1rem;"]);

exports.Wrapper = Wrapper;

var WrapperShipment = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentCardStyles__WrapperShipment",
  componentId: "sc-71wkur-1"
})(["display:flex;flex-direction:row;"]);

exports.WrapperShipment = WrapperShipment;

var WrapperShipmentInfo = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentCardStyles__WrapperShipmentInfo",
  componentId: "sc-71wkur-2"
})(["display:flex;flex-direction:row;padding-right:1.8rem;"]);

exports.WrapperShipmentInfo = WrapperShipmentInfo;

var IconShipment = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentCardStyles__IconShipment",
  componentId: "sc-71wkur-3"
})(["height:1.2rem;width:1.2rem;background:#a7b6d6;border-radius:0.2rem;margin-right:0.5rem;margin-top:4px;cursor:pointer;display:flex;justify-content:center;align-items:center;color:black;font-weight:bold;"]);

exports.IconShipment = IconShipment;

var IconSmallShipment = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentCardStyles__IconSmallShipment",
  componentId: "sc-71wkur-4"
})(["height:0.8rem;width:0.8rem;background:#2f3b52;border-radius:0.2rem;"]);

exports.IconSmallShipment = IconSmallShipment;

var TravelShipment = _styledComponents["default"].span.withConfig({
  displayName: "ShipmentCardStyles__TravelShipment",
  componentId: "sc-71wkur-5"
})(["color:white;font-weight:bold;font-size:1rem;"]);

exports.TravelShipment = TravelShipment;

var FolioShipment = _styledComponents["default"].span.withConfig({
  displayName: "ShipmentCardStyles__FolioShipment",
  componentId: "sc-71wkur-6"
})(["font-size:0.9rem;color:#8190a9;"]);

exports.FolioShipment = FolioShipment;

var TitleWrapperShipment = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentCardStyles__TitleWrapperShipment",
  componentId: "sc-71wkur-7"
})(["display:flex;flex-direction:column;"]);

exports.TitleWrapperShipment = TitleWrapperShipment;

var WrapperShipmentLogos = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentCardStyles__WrapperShipmentLogos",
  componentId: "sc-71wkur-8"
})(["display:flex;flex-direction:row;"]);

exports.WrapperShipmentLogos = WrapperShipmentLogos;

var CompanyLogoShipment = _styledComponents["default"].figure.withConfig({
  displayName: "ShipmentCardStyles__CompanyLogoShipment",
  componentId: "sc-71wkur-9"
})(["height:1.4rem;width:1.4rem;border-radius:100%;margin-right:0.1rem;"]);

exports.CompanyLogoShipment = CompanyLogoShipment;

var CompanyLogoImgShipment = _styledComponents["default"].img.withConfig({
  displayName: "ShipmentCardStyles__CompanyLogoImgShipment",
  componentId: "sc-71wkur-10"
})(["width:100%;height:100%;border-radius:100%;"]);

exports.CompanyLogoImgShipment = CompanyLogoImgShipment;

var CourierLogoShipment = _styledComponents["default"].figure.withConfig({
  displayName: "ShipmentCardStyles__CourierLogoShipment",
  componentId: "sc-71wkur-11"
})(["height:1.4rem;width:1.4rem;border-radius:100%;"]);

exports.CourierLogoShipment = CourierLogoShipment;

var CourierLogoImgShipment = _styledComponents["default"].img.withConfig({
  displayName: "ShipmentCardStyles__CourierLogoImgShipment",
  componentId: "sc-71wkur-12"
})(["width:100%;height:100%;border-radius:100%;"]);

exports.CourierLogoImgShipment = CourierLogoImgShipment;

var WrapperShipmentLevel = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentCardStyles__WrapperShipmentLevel",
  componentId: "sc-71wkur-13"
})(["display:flex;flex-direction:row;justify-content:flex-end;flex:auto 1;"]);

exports.WrapperShipmentLevel = WrapperShipmentLevel;

var ContainerLevelShipment = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentCardStyles__ContainerLevelShipment",
  componentId: "sc-71wkur-14"
})(["display:flex;flex-direction:column;align-items:center;position:", ";", ";", ";", ";", ";"], function (props) {
  return props.position ? props.position : 'normal';
}, function (props) {
  return "left:".concat(props.left) || '0';
}, function (props) {
  return "right:".concat(props.right) || '0';
}, function (props) {
  return "top:".concat(props.top) || '0';
}, function (props) {
  return "bottom:".concat(props.bottom) || '0';
});

exports.ContainerLevelShipment = ContainerLevelShipment;

var TitleLevelShipment = _styledComponents["default"].span.withConfig({
  displayName: "ShipmentCardStyles__TitleLevelShipment",
  componentId: "sc-71wkur-15"
})(["color:", ";font-size:0.9rem;"], function (props) {
  return props.color || 'white';
});

exports.TitleLevelShipment = TitleLevelShipment;

var NumberLevelShipment = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentCardStyles__NumberLevelShipment",
  componentId: "sc-71wkur-16"
})(["height:1.2rem;width:1.2rem;margin-top:0.2rem;background:", ";color:", ";display:flex;justify-content:center;align-items:center;"], function (props) {
  return props.background || '#455e88';
}, function (props) {
  return props.color || 'black';
});

exports.NumberLevelShipment = NumberLevelShipment;

var LabelWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentCardStyles__LabelWrapper",
  componentId: "sc-71wkur-17"
})(["display:flex;flex-direction:row;padding-top:0.8rem;"]);

exports.LabelWrapper = LabelWrapper;

var WrapperOtherData = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentCardStyles__WrapperOtherData",
  componentId: "sc-71wkur-18"
})(["display:flex;flex-direction:column;padding-left:0.5rem;"]);

exports.WrapperOtherData = WrapperOtherData;

var LocationOtherData = _styledComponents["default"].span.withConfig({
  displayName: "ShipmentCardStyles__LocationOtherData",
  componentId: "sc-71wkur-19"
})(["color:white;font-weight:bold;font-size:1rem;"]);

exports.LocationOtherData = LocationOtherData;

var DatetimeOtherData = _styledComponents["default"].span.withConfig({
  displayName: "ShipmentCardStyles__DatetimeOtherData",
  componentId: "sc-71wkur-20"
})(["font-size:0.9rem;color:#8190a9;"]);

exports.DatetimeOtherData = DatetimeOtherData;

var WrapperLabels = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentCardStyles__WrapperLabels",
  componentId: "sc-71wkur-21"
})(["display:flex;flex-direction:row;align-items:flex-end;justify-content:flex-end;flex:auto 1;"]);

exports.WrapperLabels = WrapperLabels;

var ManouverIconLabel = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentCardStyles__ManouverIconLabel",
  componentId: "sc-71wkur-22"
})(["height:1.4rem;width:1rem;"]);

exports.ManouverIconLabel = ManouverIconLabel;